import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-eye',
  imports: [],
  templateUrl: './icon-eye.component.html',
})
export class IconEyeComponent {
  @Input() color: string = '#494949';
  @Input() size: string = '21px';
}
